import React, { Component } from "react";
import { Helmet } from "react-helmet";
import sortBy from "lodash/sortBy";

import { mergedRoutes } from "../routes/utils";
import Mobile from "../components/MobileMainPages";
import { isMobile } from "../utils/browser";
import { MainLayoutProvider } from "../components/MainLayoutProvider/MainLayoutProvider";
import { ViewportHeight } from "../components/ViewportHeight/ViewportHeight";
import { Navbar } from "../components/Navbar/Navbar";
import { PageTransition } from "../components/Transition/PageTransition";
import { CookieNotice } from "../components/CookieNotice/CookieNotice";
import styles from "../styles/longread";

export class MainLayout extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { routes: staticRoutes } = nextProps;
    const { routes } = prevState;

    if (routes.length === 0) {
      return {
        routes: mergedRoutes({ routes: staticRoutes, ...nextProps }),
      };
    }

    return null;
  }

  state = {
    isMobile: null,
    routes: [],
  };

  componentDidMount() {
    this.setState({
      isMobile: isMobile(),
    });
  }

  render() {
    const { isMobile, routes } = this.state;
    const { children, location, titles: titlesQl, news, contacts, navigate } = this.props;
    const titles = titlesQl ? titlesQl.edges.map(({ node }) => ({ ...node.frontmatter })) : [];

    if (isMobile === null) {
      return null;
    }

    const newsSection =
      news && news.edges
        ? sortBy(
            news.edges.map(({ node }) => ({ ...node.frontmatter, id: node.id })),
            "date",
          ).reverse()
        : [];
    const newContacts = contacts ? contacts.edges[0].node.frontmatter : {};

    return (
      <>
        <Helmet
          htmlAttributes={{
            class: isMobile && styles.londreadHtmlMobile,
          }}
          bodyAttributes={{
            class: isMobile && styles.londreadBodyMobile,
          }}
        />
        <CookieNotice navigate={navigate} location={location} />
        <ViewportHeight />
        {isMobile ? (
          <Mobile
            routes={routes}
            news={newsSection}
            titles={titles}
            navigate={navigate}
            location={location}
            contacts={newContacts}
          />
        ) : (
          <MainLayoutProvider
            routes={routes}
            news={newsSection}
            contacts={newContacts}
            titles={titles}
          >
            <Navbar location={location} data={titles} routes={routes} />
            <PageTransition location={location} routes={routes}>
              {children}
            </PageTransition>
          </MainLayoutProvider>
        )}
      </>
    );
  }
}
